<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/purchase_order/"
                       data-key="purchase_orders"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-on="$listeners"
                       v-bind="$attrs">
    <template #item.id="{value}">
      {{ `PO${value.toString().padStart(10, "0")}` }}
    </template>
    <template #item.recipient="{value}">
      {{ value ? $t('name', {given_name: value.given_name, surname: value.surname}) : '' }}
    </template>
    <template #item.issued_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.due_at="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.amount="{value}">
      {{ parseInt(value) / 100.0 }}
    </template>
    <template #item.paid="{value}">
      {{ parseInt(value) / 100.0 }}
    </template>
    <template #item.due="{item}">
      {{ (parseInt(item.amount) - parseInt(item.paid)) / 100 }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="editItem(item)">
            <v-icon>fas fa-search</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('detail') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 v-if="item.settled_invoice_count === 0"
                 @click="deleteItem(item)">
            <v-icon>fas fa-trash</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('delete') }}</span>
      </v-tooltip>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import EditPurchaseOrderModal from "@/components/acc_booking/purchase_order/EditPurchaseOrderModal.vue";

export default {
  name: 'AdminPurchaseOrderList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    extraParams: Object,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_purchase_order.id'), value: 'po_no', contains: true},
        {text: root.$t('admin_acc_purchase_order.recipient_hkiarace_no'), value: 'recipient.hkiarace_account.id', contains: true},
        {text: root.$t('admin_acc_purchase_order.issued_at'), value: 'issued_at', datetime_date_range: true},
        {text: root.$t('admin_acc_purchase_order.due_at'), value: 'due_at', datetime_date_range: true},
        {text: root.$t('admin_acc_purchase_order.title'), value: 'title', contains: true},
        {
          text: root.$t('admin_acc_purchase_order.status'), value: 'status',
          options: [
            // {text: 'DRAFT', value: 'DRAFT'},
            // {text: 'CONFIRMED', value: 'CONFIRMED'},
            {text: 'OPEN', value: 'OPEN'},
            {text: 'SETTLED', value: 'SETTLED'},
            {text: 'VOIDED', value: 'VOIDED'},
          ],
        },
      ]
    })

    // Data Table
    const headers = ref([
      // {text: root.$t('admin_acc_purchase_order.created_by'), value: 'created_by', sortable: false},
      {text: root.$t('admin_acc_purchase_order.id'), value: 'id'},
      {text: root.$t('admin_user.serial_no'), value: 'recipient.hkiarace_id', sortable: false},
      {text: root.$t('admin_acc_purchase_order.recipient'), value: 'recipient', sortable: false},
      {text: root.$t('admin_acc_purchase_order.issued_at'), value: 'issued_at'},
      {text: root.$t('admin_acc_purchase_order.due_at'), value: 'due_at'},
      {text: root.$t('admin_acc_purchase_order.title'), value: 'title', sortable: false},
      {text: root.$t('admin_acc_purchase_order.amount'), value: 'amount', sortable: false},
      {text: root.$t('admin_acc_purchase_order.paid'), value: 'paid', sortable: false},
      {text: root.$t('admin_acc_purchase_order.due'), value: 'due', sortable: false},
      {text: root.$t('admin_acc_purchase_order.status'), value: 'status', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_purchase_order.delete_confirm_msg'))) {
        root.$callAPI('aafb/admin/purchase_order/delete/', {
          purchase_order_id: item.id,
        }, (response) => {
          refresh();
        })
      }
    }
    const editItem = async function (item) {
      await root.$dialog.showAndWait(EditPurchaseOrderModal, {
        purchaseOrderId: item.id,
        persistent: true,
        width: '80vw',
      })
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      BOOKING_STATUS,
      BOOKING_STATUS_LABEL,

      deleteItem,
      editItem,
    }
  }
}
</script>
